import React, { useState, useMemo } from "react";
import styles from "./Products.module.scss";
import CartItem from "../CartItem/CartItem";

import bg1 from "./../images/black-1.jpg";
import bg2 from "./../images/red-1.webp";

export interface Product {
  id: string;
  name: string;
  article: string;
  image: string;
  price: number;
  quantity: number;
}

const mockCartItems: Product[] = [
  {
    id: "1",
    name: "TEST BLACK",
    article: "ЛУ007",
    image: bg1,
    price: 627,
    quantity: 1,
  },
  {
    id: "2",
    name: "TEST RED",
    article: "ТИ301/1",
    image: bg2,
    price: 825,
    quantity: 1,
  },
];

const getProductCountText = (count: number): string => {
  if (count % 10 === 1 && count % 100 !== 11) {
    return `${count} товар`;
  }
  if (count % 10 >= 2 && count % 10 <= 4 && (count % 100 < 10 || count % 100 >= 20)) {
    return `${count} товара`;
  }
  return `${count} товаров`;
};

const Products: React.FC = () => {
  const [cartItems, setCartItems] = useState<Product[]>(mockCartItems);

  const handleQuantityChange = (itemId: string, newQuantity: number) => {
    setCartItems((prevItems) => prevItems.map((item) => (item.id === itemId ? { ...item, quantity: newQuantity } : item)));
  };

  const handleRemoveItem = (itemId: string) => {
    setCartItems((prevItems) => prevItems.filter((item) => item.id !== itemId));
  };

  const totalAmount = useMemo(() => {
    return cartItems.reduce((sum, item) => sum + item.price * item.quantity, 0);
  }, [cartItems]);

  const totalItemsCount = useMemo(() => {
    return cartItems.length;
  }, [cartItems]);

  return (
    <section className={styles.products}>
      <div className="container">
        <div className={styles.cartHeader}>
          <h2 className={styles.cartTitle}>Корзина</h2>
          {totalItemsCount > 0 && <p className={styles.cartCount}>{getProductCountText(totalItemsCount)}</p>}
        </div>
        {cartItems.length > 0 ? (
          <>
            <div className={styles.cartBody}>
              {cartItems.map((item) => (
                <CartItem key={item.id} item={item} onQuantityChange={handleQuantityChange} onRemoveItem={handleRemoveItem} />
              ))}
            </div>
            <div className={styles.cartFooter}>
              <div className={styles.totalInfo}>
                <span className={styles.totalLabel}>Итого:</span>
                <span className={styles.totalAmount}>{totalAmount.toFixed(0)} р.</span>
              </div>
              <button className={styles.checkoutButton}>Продолжить оформление</button>
            </div>
          </>
        ) : (
          <p className={styles.emptyCartMessage}>Ваша корзина пуста.</p>
        )}
      </div>
    </section>
  );
};

export default Products;
